import { Button, Select } from "../../../components/ReadonlyAwareInputs";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const RequestAccess = ({
  otherGroupList,
  requestGroup,
  setRequestGroup,
  setRequestAccessModal,
  isLoading,
  fetchGroups,
  dropdownsDisabled,
}) => {
  return (
    <div className="row">
      <p className="col-3 text-vertical-center">
        Request access to an existing group:
      </p>
      <Select
        className="col"
        disabled={isLoading || dropdownsDisabled}
        searchable
        data={getNamesFromList(otherGroupList)}
        onSelect={(groupName) => {
          setRequestGroup({
            id: getIdByName(groupName, otherGroupList),
            name: groupName,
          });
        }}
      ></Select>
      <div className="col-4" style={{ padding: 0 }}>
        <Button
          style={{
            width: "100%",
            height: "100%",
            margin: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            setRequestAccessModal(true);
          }}
          disabled={!requestGroup?.id || dropdownsDisabled}
        >
          Request access
        </Button>
      </div>
    </div>
  );
};

export default RequestAccess;
